import { render, staticRenderFns } from "./part-one.vue?vue&type=template&id=286ca5da&scoped=true"
import script from "./part-one.vue?vue&type=script&lang=js"
export * from "./part-one.vue?vue&type=script&lang=js"
import style0 from "./part-one.vue?vue&type=style&index=0&id=286ca5da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ca5da",
  null
  
)

export default component.exports